module.exports = __webpack_public_path__ + "img/selo_sif.97f726c5.png";